import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => {
  return (
    <SectionContainer
      id='leaders-header'
      disableBottomPadding>
      <Row align='center'>
        <Col align='center'>
          <Typography
            component='h1'
            disableBottomPadding>
            Our Leaders
          </Typography>
        </Col>
      </Row>
    </SectionContainer>
  );
};
